import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const MarineOpenFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1. What types of shipments can be covered?",
      answer: (
        <>
            A Marine Open Policy (MOP) offers a comprehensive insurance solution for businesses that frequently engage in international maritime cargo transportation.  An MOP provides blanket coverage for <span style={{ color: "#F37435", fontWeight: "700"}}>a wide range of goods shipped by sea,</span> streamlining the insurance process and potentially reducing costs compared to individual shipment policies.
        </>
      )
    },
    {
      question: "Q2. How does a marine open policy differ from a single transit policy?",
      answer: (
        <>
         <span style={{ color: "#F37435", fontWeight: "700"}}>Marine Open Policy:</span>
         <ol>
          <li style={{ color: "black" }}>Coverage: Covers multiple shipments over a set period, usually a year.</li>
          <li style={{ color: "black" }}>Convenience: Ideal for businesses with frequent shipments, as it automatically covers all shipments within the policy period.</li>
          <li style={{ color: "black" }}>Administration: Requires periodic reporting of shipments to the insurer.</li>
         </ol>
       
      
       <span style={{ color: "#F37435", fontWeight: "700"}}>Single Transit Policy:</span>
       <ol>
       <li style={{ color: "black" }}>Coverage: Covers a single, specific shipment.</li>
       <li style={{ color: "black" }}>Convenience: Suitable for businesses with occasional shipments, providing coverage for one transit event.</li>
       <li style={{ color: "black" }}>Administration: No ongoing reporting needed.</li>
       </ol>
       </>
      )
    },
    {
      question: "Q3. How are premiums determined?",
      answer:(
        <>
       Premiums for Group Credit Life Insurance are generally calculated based on the loan amount, the term of the loan, the borrower's age, and health status. Since it’s a group policy, premiums can be lower than individual credit life insurance due to the risk being spread across many borrowers.
      </>
      )
      },

      {
        question: "Q4. How are premiums calculated for a marine open policy?",
        answer:(
          <>
           Premiums for a marine open policy are determined based on factors such as the estimated <span style={{ color: "#F37435", fontWeight: "700"}}> annual turnover of shipped goods, the nature of the goods being transported, shipping routes and destinations, claims history, security measures implemented, chosen deductibles and coverage limits, optional coverages, and current market conditions.</span> Insurers assess these factors to calculate a premium that reflects the level of risk associated with the insured shipments.
        </>
        )
        },
    {
      question: "Q5. How do I report a claim under a marine open policy?",
      answer: (
        <>
         If you ever need to report a claim under your marine open policy, just <span style={{ color: "#F37435", fontWeight: "700"}}>head over to our "Claim Assistance" </span>section in the navigation bar. There, you'll find all the information you need, including step-by-step instructions on how to report a claim effectively. We're here to guide you through the process and ensure it's as straightforward as possible.
        </>
      )
      
    
    },
    {
        question: "Q6. What steps can I take to minimize risks under a marine open policy?",
        answer: (
        
          <>
  <div>
    <span style={{ color: "#F37435", fontWeight: "700" }}>
      • Secure Packaging:
    </span> 
    Properly package goods to withstand the rigors of transit, reducing the likelihood of damage during handling and transport.
  </div>
  <div>
    <span style={{ color: "#F37435", fontWeight: "700" }}>
      • Choose Reliable Carriers:
    </span>
    Select shipping providers with a proven track record for reliability and safe delivery practices to minimize the risk of loss or delays.
  </div>
  <div >
    <span style={{ color: "#F37435", fontWeight: "700" }}>
      • Compliance with Regulations:
    </span>
    Follow strictly to shipping regulations and safety standards applicable to your industry and the regions you ship to. This ensures compliance with legal requirements and reduces the risk of penalties or operational disruptions.
  </div>
  <div>
    <span style={{ color: "#F37435", fontWeight: "700" }}>
      • Thorough Documentation:
    </span>
    Maintain proper records of shipments, including bills of lading, packing lists, and insurance documentation. This documentation is crucial for verifying the contents of shipments and expediting claims processing in case of loss or damage.
  </div>

</>
        
        )
        
      
      },
      {
        question: "Q7. How often do I need to declare shipments to my insurer?",
        answer: (
          <>
           Under a marine open policy, you typically need to declare shipments to your insurer on a<span style={{ color: "#F37435", fontWeight: "700"}}>regular basis, often monthly or quarterly.</span> This reporting ensures that your insurer is aware of the shipments you've made during that period and can accurately assess your premium based on the actual value and frequency of shipments. It also helps maintain compliance with the terms of your policy and facilitates efficient claims processing if necessary. It's important to follow the reporting requirements specified in your policy to maintain continuous coverage and avoid any potential coverage disputes.
          </>
        )
        
      
      },
      {
        question: "Q8. How do I report a claim under a marine open policy?",
        answer: (
          <>
           If you ever need to report a claim under your marine open policy, just head over to our "Claim Assistance" section in the navigation bar. There, you'll find all the information you need, including step-by-step instructions on how to report a claim effectively. We're here to guide you through the process and ensure it's as straightforward as possible.
          </>
        )
        
      
      },
  
   
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default  MarineOpenFAQ;